export enum StatsElementChartFormBlock {
  Root = 'StatsElementChartForm',
}

export enum StatsElementChartFormElement {
  Select = 'select',
}
